import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=6b75a8c9&scoped=true"
var script = {}
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=6b75a8c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b75a8c9",
  null
  
)

export default component.exports